import styled from "styled-components";

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  min-height: 0;
`;

export const ContentArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;


export const Subtitle = styled.div`
  color: #5c5c5c;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ScrollWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 280px);
  overflow: hidden;

  > * {
    flex: 1;
    min-height: 0;
    height: 100%;
  }
`;

export const ScrollContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 8px;
`;



export const EmptyState = styled.div`
  flex: 1;
  border: 1px solid
    ${({ theme }) =>
      theme?.palette?.border?.neutral?.default || "rgba(28, 42, 58, 0.1)"};
  border-radius: 16px;
  padding: 48px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;
